export default {
  nav: {
    title: 'Utils',
  }
}
